export const FOOTER_CONFIG = {
  payment_methods: [
    {
      name: 'Visa',
      icon: '/images/payments/visa.png',
    },
    {
      name: 'Mastercard',
      icon: '/images/payments/mastercard.png',
    },
    {
      name: 'Apple pay',
      icon: '/images/payments/applepay.png',
    },
    {
      name: 'Google pay',
      icon: '/images/payments/googlepay.png',
    },
  ],
  deliveries: [
    {
      name: 'DPD',
      icon: '/images/deliveries/dpd.png',
    },
    {
      name: 'SPS',
      icon: '/images/deliveries/sps.png',
    },
    {
      name: 'Packeta',
      icon: '/images/deliveries/packeta.png',
    },
  ],
};
